// import { useLocation } from "react-router-dom";
// import ContactSection from "../components/ContactForm";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import HeroSection from "../components/HeroSection";
// import HeroSection2 from "../components/HeroSection2";
// import ServicesSection from "../components/Services";
// import { useEffect } from "react";

// export default function ContactUs () {
//     const { pathname } = useLocation();
//     useEffect(() => {
//       window.scrollTo(0, 0);
//     }, [pathname]);

//    return(
//     <div className="font-body">
//     <Header />
      
//       <ContactSection />
//       <Footer />
//   </div>
//    )
  
// }
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ContactInfo = () => {
  return (
    <div>
      <Header />
    <div className="bg-black text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-sky-400 mb-4">Get In Touch</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Have questions about our services? We're here to help and would love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* Office Location */}
          <div className="bg-gray-900 p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <svg className="w-12 h-12 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-sky-300 mb-2">Our Office</h3>
            <p className="text-gray-300">
            6th Floor, Haveli Arcade, 603 - 604, Sector 11, Gandhinagar, Gujarat 382011
            </p>
          </div>

          {/* Contact Info */}
          <div className="bg-gray-900 p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <svg className="w-12 h-12 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-sky-300 mb-2">Contact Info</h3>
            <p className="text-gray-300 mb-2">
              <span className="font-medium">Email:</span><br />
              <a href="mailto:info@capitaloffset.com" className="text-sky-400 hover:text-sky-300">
              hello@capitalplussoftware.com
              </a>
            </p>
            <p className="text-gray-300">
              <span className="font-medium">Phone:</span><br />
              <a href="tel:+12125551234" className="text-sky-400 hover:text-sky-300">
              6354616326
              </a>
            </p>
          </div>

          {/* Business Hours */}
          <div className="bg-gray-900 p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <svg className="w-12 h-12 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-sky-300 mb-2">Business Hours</h3>
            <div className="text-gray-300">
              <p className="mb-1"><span className="font-medium">Monday-Friday:</span> 9AM - 6PM</p>
              <p className="mb-1"><span className="font-medium">Saturday:</span> 10AM - 2PM</p>
              <p><span className="font-medium">Sunday:</span> Closed</p>
            </div>
          </div>
        </div>

  
      </div>
    </div>
    <Footer />
    </div>
  );
};

export default ContactInfo;